Object.defineProperty(exports,"__esModule",{value:true});
var _helpers=require('./helpers');

var preRequestHandler=[];
var postRequestHandler=[];
var authTokenChangeListeners=[];
var isConnected=false;

function request(url,config){
var requestInitTime=new Date();
var fullUrl=config.baseUrl?config.baseUrl+url:url;

config=preRequestHandler.reduce(function(conf,fn){return fn(conf,url)||conf;},config);

if(config.stepUpToken){
config.headers['X-Stepup-Token']=config.stepUpToken;
}

if(typeof config.then==='function'){
return config.then(function(result){return(
postRequestHandler.reduce(function(res,fn){return fn(res,url,config)||res;},result));});
}

return new Promise(function(resolve,reject){
if(process.env.NODE_ENV!=='production'&&
console&&console.groupCollapsed&&console.info){
console.info('[db-request] Requesting '+url+'. '+requestInitTime+'. See details in group.');
}

if(!config.headers['Accept']){
config.headers['Accept']='*/*';
}

var status=void 0;
var requestId=null;
var promise=fetch(fullUrl,config).
then(function(response){
requestId=response.headers.get('X-Request-ID');
if(response.headers.get('Persistent-Auth')!==null&&
response.headers.get('Persistent-Auth')!==undefined){
var token=response.headers.get('Persistent-Auth');
_helpers.defaultConfig.headers['Authorization']=token;

authTokenChangeListeners.forEach(function(listener){return listener(token);});
}
return response;
}).
then(function(response){return(
postRequestHandler.reduce(function(res,fn){return fn(res,url,config)||res;},response));}).
then(function(response){
status=response.status;
if(typeof response.json==='function'){
switch(config.responseType){
case'json':
return response.json();
case'blob':
return response.blob();
case'original':
return response;
default:
return response.text();}

}

return response;
});

if(process.env.NODE_ENV!=='production'&&console&&
console.groupCollapsed&&console.info&&console.warn&&console.groupEnd){
promise.then(function(result){
var responseReceivedTime=new Date();
console.groupCollapsed('[db-request] '+url+'. '+requestInitTime);
console.info('Finished at '+responseReceivedTime);
console.info('Elapsed time: '+(responseReceivedTime-requestInitTime)+' ms');
console.info('Configuration used:',config);
console.info('Result:',result);
console.groupEnd();
return result;
},function(error){
var responseReceivedTime=new Date();
console.groupCollapsed('[db-request] '+url+'. '+requestInitTime);
console.info('Finished at '+responseReceivedTime);
console.info('Elapsed time: '+(responseReceivedTime-requestInitTime)+' ms');
console.info('Configuration used:',config);
console.warn('Error:',error);
console.groupEnd();
console.warn('[db-request] Ended in error. '+Date());
});
}

promise.then(function(response){
if(status===200){
resolve(response);
}else{
reject({error:response,requestId:requestId,status:status,isConnected:isConnected});
}
}).catch(function(error){return reject({error:error,requestId:requestId,status:status,isConnected:isConnected});});
});
}exports.default=

{
setServerConfig:function setServerConfig(config){
if(config.clientId){
_helpers.defaultConfig.headers['X-IBM-Client-Id']=config.clientId;
}
if(config.clientSecret){
_helpers.defaultConfig.headers['X-IBM-Client-Secret']=config.clientSecret;
}
if(config.baseUrl){
_helpers.defaultConfig.baseUrl=config.baseUrl;
}
},
setUserAgent:function setUserAgent(userAgent){
_helpers.defaultConfig.headers['User-Agent']=userAgent;
},
setAppVersion:function setAppVersion(appVersion){
_helpers.defaultConfig.headers['X-App-Version']=appVersion;
},
setDevice:function setDevice(device){
_helpers.defaultConfig.headers['X-Device']=device;
},
setAppCulture:function setAppCulture(culture){
_helpers.defaultConfig.headers['X-App-Culture']=culture;
},
setReferer:function setReferer(referer){
_helpers.defaultConfig.headers['Referer']=referer;
},
getDefaultConfig:function getDefaultConfig(){
return(0,_helpers.mergeConfig)({});
},
clearAuthToken:function clearAuthToken(){
delete _helpers.defaultConfig.headers['Authorization'];
},
getAuthToken:function getAuthToken(){
return _helpers.defaultConfig.headers['Authorization'];
},
setAuthToken:function setAuthToken(token){
_helpers.defaultConfig.headers['Authorization']=token;
},
addHeader:function addHeader(header,value){
_helpers.defaultConfig.headers[header]=value;
},
removeHeader:function removeHeader(header){
delete _helpers.defaultConfig.headers[header];
},
getHeader:function getHeader(header){
return _helpers.defaultConfig.headers[header];
},
onAuthTokenChange:function onAuthTokenChange(cb){
authTokenChangeListeners.push(cb);
return function unsubscribe(){
var index=authTokenChangeListeners.indexOf(cb);
if(index>-1){
authTokenChangeListeners.splice(index,1);
}
};
},
setIsConnected:function setIsConnected(value){
isConnected=value;
},
addPreRequestHandler:function addPreRequestHandler(cb){
preRequestHandler.push(cb);
return function unsubscribe(){
var index=preRequestHandler.indexOf(cb);
if(index>-1){
preRequestHandler.splice(index,1);
}
};
},
addPostRequestHandler:function addPostRequestHandler(cb){
postRequestHandler.push(cb);
return function unsubscribe(){
var index=postRequestHandler.indexOf(cb);
if(index>-1){
postRequestHandler.splice(index,1);
}
};
},
call:function call(url,config){
return request(url,config);
},
get:function get(url){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
var getConfig={
method:'GET'};

var requestConfig=(0,_helpers.mergeConfig)(getConfig,config);
return request(url,requestConfig);
},
head:function head(url){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
var headConfig={
method:'HEAD'};

var requestConfig=(0,_helpers.mergeConfig)(headConfig,config);
return request(url,requestConfig);
},
delete:function _delete(url){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
var deleteConfig={
method:'DELETE'};

var requestConfig=(0,_helpers.mergeConfig)(deleteConfig,config);
return request(url,requestConfig);
},
post:function post(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};
var postConfig={
method:'POST',
body:JSON.stringify(data)};

var requestConfig=(0,_helpers.mergeConfig)(postConfig,config);
return request(url,requestConfig);
},
put:function put(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};
var putConfig={
method:'PUT',
body:JSON.stringify(data)};

var requestConfig=(0,_helpers.mergeConfig)(putConfig,config);
return request(url,requestConfig);
},
patch:function patch(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};
var putConfig={
method:'PATCH',
body:JSON.stringify(data)};

var requestConfig=(0,_helpers.mergeConfig)(putConfig,config);
return request(url,requestConfig);
},
_clear:function _clear(){
preRequestHandler.length=0;
postRequestHandler.length=0;
}};